import { Grid2 as Grid, Paper, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material';
import React, { useContext } from 'react';
import ClockIcon from '../../assets/icons/clockIcon.svg';
import DollarIcon from '../../assets/icons/dollarSign.svg';
import { formatProductDurationDetail } from '../../utils/functions/productCardMeta';
import { ProductsStore } from '../../utils/stores/ProductsStore';
import { widgetStyles } from './widgets/widgetStyles';

const formatFare = (price?: number) => {
    if (price == null) return '';
    return price === 0 ? 'Free' : `$${price}`;
};

export default function KeyDetailWidget() {
    const productController = useContext(ProductsStore);
    const theme = useTheme();
    const mediumDown = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Paper variant="outlined" sx={[widgetStyles.paper, widgetStyles.paperLeft]}>
            <Grid container alignItems="center" sx={widgetStyles.gridContainer}>
                <Grid size={{ xs: 12 }} style={{ paddingBottom: 20 }}>
                    <Typography variant="h5" style={{ fontWeight: 500 }}>
                        {productController.product?.priceOptions.length === 1 ? 'Price' : 'Prices'}
                    </Typography>
                </Grid>
                <Grid size={{ xs: 2 }}>
                    <img
                        src={DollarIcon}
                        alt={`${productController.product?.name} pricing`}
                        style={{ height: mediumDown ? 24 : 30 }}
                    />
                </Grid>
                <Grid size={{ xs: 10 }}>
                    {productController.product?.priceOptions.map((option) => (
                        <Grid container justifyContent="space-between" key={`${option.label} price`}>
                            <Grid size={{ xs: 9 }} style={{ paddingRight: 10 }}>
                                <Typography variant="h6" sx={widgetStyles.detailText}>
                                    {option.label}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 3 }}>
                                <Typography
                                    key={`${option.label} price`}
                                    variant="h6"
                                    align="right"
                                    sx={widgetStyles.detailText}
                                >
                                    {formatFare(option.price)}
                                </Typography>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
                <Typography variant="body2" style={{ opacity: 0.8, marginTop: 10 }}>
                    Please check the final price once you commence a booking. Prices may may differ based on the
                    departure date &amp; time.
                </Typography>
            </Grid>
            <Grid container alignItems="center">
                <Grid size={{ xs: 12 }} style={{ paddingBottom: 20 }}>
                    <Typography variant="h5" style={{ fontWeight: 500 }}>
                        Duration
                    </Typography>
                </Grid>
                <Grid size={{ xs: 2 }}>
                    <img
                        src={ClockIcon}
                        alt={`${productController.product?.name} duration`}
                        style={{ height: mediumDown ? 24 : 30 }}
                    />
                </Grid>
                <Grid size={{ xs: 10 }}>
                    <Typography variant="h6" sx={widgetStyles.detailText}>
                        {formatProductDurationDetail(productController.product)}
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
}
